<template>
  <div></div>
</template>

<script>
  import * as turf from '@turf/turf'

  export default {
    name: 'map-marker',

    props: {
      google: Object,
      map: Object,
      geojson: Object,
      editable: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        marker: new this.google.maps.Marker({ map: this.map })
      }
    },

    methods: {
      moveTo(geojson) {
        let googlePoint = {
          lng: geojson.geometry.coordinates[0],
          lat: geojson.geometry.coordinates[1]
        }

        this.marker.setPosition(googlePoint)
        this.map.setCenter(googlePoint)
      }
    },

    watch: {
      geojson: function(value) {
        this.moveTo(this.geojson)
      }
    },

    mounted() {
      google.maps.event.addListener(this.map, 'dragend', () => {
        if (!this.editable) return

        let center = this.map.getCenter()
        let centerGeoJSON = turf.point([ center.lng(), center.lat() ])

        this.$store.commit('setCoordinates', centerGeoJSON)
        this.$store.commit('setGeoJSON', centerGeoJSON)
        this.moveTo(centerGeoJSON)
      })
    }
  }
</script>

<style lang="scss" scoped>
div {
  opacity: 0;
  width: 0;
  height: 0;
}
</style>
